import { isAuthenticatedUser } from 'js/lib/user';

import GrowthDiscoveryEpicClient from 'bundles/epic/clients/GrowthDiscovery';
import PATHWAY_SLUGS from 'bundles/unified-description-page-common/constants/pathways';

// Full rollout for NAMER region only
export const showPathwaysNamer = () => {
  return GrowthDiscoveryEpicClient.get('showPathwaysNAMER');
};

export const showPathwaysUserBased = () => {
  return showPathwaysNamer() || GrowthDiscoveryEpicClient.get('showPathwaysGlobalHoldout2025');
};

export const isPathwaysXDP = (slug: string) => {
  return PATHWAY_SLUGS.includes(slug);
};

export const showPathwaysXDP = (slug: string) => {
  if (!slug || !PATHWAY_SLUGS.includes(slug)) {
    return false;
  }

  if (isAuthenticatedUser() && !showPathwaysUserBased()) {
    return false;
  }

  return true;
};

export const showPathwaysCareerAcademyPages = () => {
  if (isAuthenticatedUser() && !showPathwaysUserBased()) {
    return false;
  }

  return true;
};

export const isInPathwaysRetriggerEpics = () =>
  (GrowthDiscoveryEpicClient.get('retriggerNamerOnboarding') && GrowthDiscoveryEpicClient.get('showPathwaysNAMER')) ||
  GrowthDiscoveryEpicClient.get('showPathwaysGlobalHoldout2025');
